module.exports = __webpack_public_path__ + "static/img/cDR2.685f5ac1.png";